import { useState, useEffect } from 'react';
import { I18n } from 'sunzi-utils';

var useI18n = function (lng, resources) {
  var _a = useState(false),
      render = _a[1];

  useEffect(function () {
    I18n.mountLng(lng, resources[lng]);
    I18n.setLng(lng);
    render(true);
  });
};

export default useI18n;
